import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=7bdd4252&scoped=true&lang=pug&"
import script from "./DataCard.vue?vue&type=script&lang=ts&"
export * from "./DataCard.vue?vue&type=script&lang=ts&"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=7bdd4252&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdd4252",
  null
  
)

export default component.exports